import { RestError } from "../../services/rest-service/RestService";
import { useQuery  } from "react-query";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import TankRelationshipDataService from "../../services/tank-relationship-data-service/TankRelationshipDataService";
import { ITankPadModel } from "../../services/tank-relationship-data-service/Models";
import { keys } from "./Keys";

export type UseTankRelationshipQueryParams = {
    groupID: number,
   
} & BaseUseQueryParameters<ITankPadModel[]>;

export function useTankRelationshipData({
    groupID, 
    enabled,
    onError,
    onSuccess,

}: UseTankRelationshipQueryParams) {
    return useQuery<ITankPadModel[], RestError>(
        keys.data(groupID),
        ({ signal }) => {
            return TankRelationshipDataService.getData(groupID, signal);
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            //staleTime: Infinity,
        }
    );
}
